import classNames from "classnames";
import moment from "moment";
import React from "react";
import { FormattedMessage } from "react-intl";
import { USER_LOG_ENTRY_TYPES } from "../../../../../api/constants";
import { dateRangeToHourValue } from "../../../../../utils/dateUtils";
import { Icon } from "../../../../graphic/Icon";
import { DurationCounter } from "../../../DurationCounter";
import styles from "./ValueStep.scss";

export const ValueStep = ({ date, hour, entry, isClickable }) => {
    const startTime = new Date(entry.startTime);
    const endTime = new Date(entry.endTime);
    const isStart =
        date.getMonth() === startTime.getMonth() &&
        date.getDate() === startTime.getDate() &&
        startTime.getHours() === hour;
    const isEnd =
        date.getMonth() === endTime.getMonth() &&
        date.getDate() === endTime.getDate() &&
        (endTime.getHours() === hour || (endTime.getHours() - 1 === hour && endTime.getMinutes() === 0));
    const hoursLength = dateRangeToHourValue(startTime, endTime);
    const minutes =
        isStart && startTime.getMinutes() > 0
            ? startTime.getMinutes()
            : isEnd && endTime.getMinutes() > 0
              ? endTime.getMinutes()
              : 60;
    const createdSecondsAgo = moment.duration(moment().diff(moment(entry.registered))).asSeconds();
    return (
        <div
            className={classNames(styles.step, {
                [styles.start]: isStart,
                [styles.end]: isEnd,
                [styles.new]: createdSecondsAgo <= 30,
                [styles.ongoingTrip]: entry.trip && !entry.endTime
            })}
            style={{ backgroundColor: USER_LOG_ENTRY_TYPES[entry.type].color, width: `${(minutes / 60) * 100}%` }}
        >
            {isClickable && <div className={styles.clickable}></div>}

            {((isStart && startTime.getHours() < 21) || (startTime.getHours() >= 21 && hour === 0)) &&
            hoursLength > 3 ? (
                <StepLabel
                    entry={entry}
                    shortened={
                        (startTime.getHours() < 21 && hoursLength <= 3) ||
                        (startTime.getHours() >= 21 && startTime.getHours() + hoursLength - 24 <= 3)
                    }
                />
            ) : null}
        </div>
    );
};

const StepLabel = ({ entry, shortened }) => {
    return (
        <div className={styles.label}>
            <DurationCounter ranges={[{ from: entry.startTime, to: entry.endTime }]} />
            {!shortened && (
                <>
                    ,&nbsp;
                    <FormattedMessage id={USER_LOG_ENTRY_TYPES[entry.type].shortLabel} />
                </>
            )}
            {entry.remarks ? (
                <div className={styles.remarks}>
                    <Icon name="comment" />
                </div>
            ) : null}
        </div>
    );
};
